import type { ActionsObservable } from 'redux-observable';
import type { AjaxError } from 'rxjs';
import type { Epic } from '@helpcenter/epics-rxjs';
import { concat, Observable } from '@helpcenter/epics-rxjs';

import { login, loginV2 } from 'rest/login';
import type { LoginAttempt, LoginAttemptFailure, LoginAttemptSuccess } from 'state/actions/login';
import { LOGIN_ATTEMPT, loginAttemptFailure, loginAttemptSuccess } from 'state/actions/login';
import type { SuccessfullyLoggedIn } from 'state/actions/user';
import { successfullyLoggedIn } from 'state/actions/user';
import { getDefaultError } from 'utils/errors';
import FeatureGates from '@atlaskit/feature-gate-js-client';

export const loginEpic: Epic<LoginAttempt, LoginAttemptSuccess | LoginAttemptFailure | SuccessfullyLoggedIn> = (
    action$: ActionsObservable<LoginAttempt>
) => {
    return action$.ofType(LOGIN_ATTEMPT).mergeMap((loginAction) => {
        const { email, password, continueParam } = loginAction.payload;

        const loginResponse = FeatureGates.checkGate('banana_4195_customer_v2_login_authenticate')
            ? loginV2(email, password, continueParam)
            : login(email, password);

        return loginResponse
            .flatMap((response) => {
                if (response.loginSucceeded) {
                    return concat(Observable.of(loginAttemptSuccess(response)), Observable.of(successfullyLoggedIn()));
                }
                return Observable.of(loginAttemptSuccess(response));
            })
            .catch((error: AjaxError) => {
                const parsedError = getDefaultError(error);
                return Observable.of(loginAttemptFailure(parsedError));
            });
    });
};
